import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 27 23",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M13.5 5.902c-.344 0-1.202.096-1.725.988L5.261 17.988c-.53.902-.184 1.703-.01 2.006.173.302.688 1.006 1.735 1.006h13.028c1.047 0 1.562-.704 1.736-1.006s.519-1.104-.011-2.006L15.225 6.89a1.97 1.97 0 0 0-1.725-.988m0-2c1.338 0 2.677.658 3.45 1.975l6.514 11.098c1.565 2.667-.358 6.025-3.45 6.025H6.986c-3.092 0-5.015-3.358-3.45-6.025L10.05 5.877a3.96 3.96 0 0 1 3.45-1.975" }),
		/* @__PURE__ */ _jsx("rect", {
			width: 3,
			height: 7,
			x: 12,
			y: 9,
			rx: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3,
			height: 3,
			x: 12,
			y: 17,
			rx: 1.5
		})
	]
});
export default SvgWarning;
